module.exports = __webpack_public_path__ + "img/cp8_02.dc04a2ba.jpg";